import { Bar } from 'vue-chartjs'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
)

export default {
    name: 'BarChart',
    components: {
        Bar
    },
    props: {
        chartData: {
            type: Object,
            required: false,
            default: () => ({ labels: [], datasets: [] })
        },
        options: {
            type: Object,
            required: false,
            default: () => ({})
        },
        height: {
            type: [Number, String],
            default: null
        },
        width: {
            type: [Number, String],
            default: null
        },
        // Chart.js plugin objects, for things the options cannot express - a
        // marker line, an annotation. Standard vue-chartjs v4 prop.
        plugins: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            internalData: null,
            internalOptions: null
        }
    },
    computed: {
        activeData() {
            return this.internalData || this.chartData
        },
        activeOptions() {
            return this.internalOptions || this.options
        }
    },
    render(h) {
        // Create wrapper div with explicit height for maintainAspectRatio: false to work
        const containerStyle = {
            position: 'relative',
            width: this.width
                ? (typeof this.width === 'number' ? `${this.width}px` : this.width)
                : '100%',
            height: this.height
                ? (typeof this.height === 'number' ? `${this.height}px` : this.height)
                : '100%'
        }
        // vue-chartjs v4 props
        const props = {
            chartData: this.activeData,
            chartOptions: this.activeOptions,
            plugins: this.plugins,
            styles: { height: '100%', width: '100%' }
        }
        return h('div', { style: containerStyle }, [
            h(Bar, {
                props,
                ref: 'barChart'
            })
        ])
    },
    methods: {
        // Backwards compatibility method - existing code calls this
        renderChart(data, options) {
            this.internalData = data
            this.internalOptions = options
            this.$forceUpdate()
        }
    }
}
